module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title",
    attrs: {
      "id": "list"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Blair Castle, Perthshire. Author’s own image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Huntingtower, Perth. View looking north. Author’s own image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Huntingtower, Perth. View looking south, only the two towers of the original castle now remain. Author’s own image with permission of Historic Environment Scotland.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("John Murray, Duke of Atholl. From the collection at Blair Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Katherine Hamilton, Duchess of Atholl. From the collection at Blair Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Memorial at St Mary’s, Kilmuir, Skye, erected to Lord Thomas Fraser, 10th Lord Lovat, father of Simon, died at Dunvegan 1699. Author’s own image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Dowager Duchess Anne Hamilton. Alamy image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Lady Margaret Nairne. Alamy image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("John Murray, Marquis of Tullibardine, died at the Battle of Malplaquet. From the collection at Blair Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("William Murray, Marquis of Tullibardine. From the collection at Blair Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Lord George Murray. From the collection at Blair Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Battle of Preston. Royal Collection Trust/© Her Majesty Queen Elizabeth II 2019")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Sheriffmuir. Author’s own image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Gathering stone at Sheriffmuir where the Jacobites are said to have assembled before the battle. Author’s own image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Map of the area around Sheriffmuir. Alamy image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Picture of the ‘Battle of Sheriffmuir’ here entitled the ‘Battle of Dumblain’ (Dunblane); artist not assigned. Picture on display at Dunblane Museum and used with their kind permission.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Scone Palace where James III briefly held court. Image Maddy Anderson 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Amelia Murray, wife of Lord George. Image from the collection at Blair Castle.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Tullibardine Chapel where Lord George wanted to be interred with his wife and children. It stood next to Tullibardine Castle, of which there are no remains. Author’s own image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Sign at Sheriffmuir commemorating the 300-year anniversary of the battle. Author’s own image.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Glenfinnan Monument, where William Marquis of Tullibardine, raised the standard marking the start of the 1745 Rising. Author’s own image.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-766d896c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List.vue
// module id = 72
// module chunks = 0